<template>
<!-- <div mx-0 px-0> -->
  <!-- <v-row> -->
  <!-- </v-row> -->
<v-container fluid pa-0>
  <v-row no-gutters wrap mx-1 px-1>
    <!-- <v-col cols="3" mx-0 px-0>
      <AppInputDrawer />
    </v-col> -->
    <v-col cols="12">
      <v-row wrap mx-2 no-gutters>
      <!-- <v-col xs="12" md="6" pa-2 d-flex> -->
        <v-col cols="6">
          <AppEnergySankey />
        </v-col>
        <v-col cols="6">
          <AppWaterSankey />
        <!-- </v-col> -->

        <!-- <v-col xs="12" md="6" pa-2 d-flex> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12">
          <v-divider/>
          <AppWeatherChart />
        </v-col>

      </v-row>
    </v-col>
  </v-row>
</v-container>
<!-- <v-row> -->
    <!-- <v-col xs="12" pa-2>
      <v-divider />
    </v-col>
</v-row> -->
  <!-- </v-row> -->
<!-- </div> -->
</template>


<script>
import AppTitle from '@/components/shared/Title'
import AppInputDrawer from '@/components/subs/inputDrawer'
import AppEnergySankey from '@/components/subs/energySankey'
import AppWaterSankey  from '@/components/subs/waterSankey'
import AppWeatherChart  from '@/components/subs/weatherChart'

export default {
  data: () => ({
    mini: true,
    drawer: true,
  }),
  computed: {

  },
  methods: {

  },
  created() {

  },
  mounted() {

  },
  components: {
    AppTitle,
    AppWeatherChart,
    AppEnergySankey,
    AppWaterSankey,
    AppInputDrawer,
  }
}
</script>
